// extracted by mini-css-extract-plugin
export default {"context-menu-anker":"context-menu_context-menu-anker__vzHI7","context-menu-content":"context-menu_context-menu-content__xbecR"};